
import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'react-feather';
import GridModal from './Modals/GridModal';

const SelectDropDownNew = ({
  disabledInput,
  productImage,
  labelName,
  page,
  requiredStar,
  options = [],
  selectedValue,
  onChange = () => {},
  setSelectedValue,
  msg,
  disabled = false,
  hasImage = false,
  openDropdown,
  setOpenDropdown
}) => {
  const isOpen = openDropdown === labelName;

  const handleOptionClick = (option) => {
    if (disabled) return;
    setSelectedValue(option);
    onChange(option);
    setOpenDropdown(null); 
  };

  const handleShowDropdownClick = (e) => {
    e.stopPropagation();
    if (disabled) return;

    setOpenDropdown(isOpen ? null : labelName);
  };

  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (!isOpen && page === 'searchFilter') {
      setSearchTerm('');
    }
  }, [isOpen, page]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      e.stopPropagation();
      if (isOpen) {
        setOpenDropdown(null);
      }
    };

    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, [isOpen, setOpenDropdown]);

  const filteredOptions =
    Array.isArray(options) && options.length
      ? options.filter((option) =>
          option.title?.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : [];

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const onClickHandler = (e) => {
    e.stopPropagation(); 
  };

  return (
    <>
      <div className={`selectBoxWrap ${disabledInput === false ? 'disabledInput' : ''}`}>
        <label className="selectDropBoxLabel form-label">
          {labelName} <span className="redStar">{requiredStar}</span>
        </label>

        <div className={`selectDropBox ${disabled ? 'disabled' : ''}`} onClick={handleShowDropdownClick}>
          <div className="registrationTopText">
            <p className="mb-0">{selectedValue?.title?.substring(0, 23) || 'Select'}</p>
            {!disabled && (
              <div className="arrow-icon">
                <ChevronDown />
              </div>
            )}
          </div>
        </div>

        {page !== 'searchFilter' && isOpen && !hasImage && (
          <div className="selectDropDownOptionBox">
            <ul>
              {options.map((option, index) => (
                <li
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className={`${selectedValue?.title === option.title ? 'selectedOption' : ''} ${
                    option.productImage ? 'selectedBlockWithImage' : ''
                  }`}
                >
                  {option.title}
                  {option.productImage && (
                    <span className="optionImage">
                      <img src={option.productImage} alt={option.title} />
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}

        {page === 'searchFilter' && isOpen && (
          <div className="selectDropDownOptionBox coloredOptionBox">
            <div className="srchFilterBox" onClick={onClickHandler}>
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
            <ul>
              {filteredOptions.map((option) => (
                <li
                  key={option.id}
                  onClick={() => handleOptionClick(option)}
                  className={selectedValue?.title === option.title ? 'selectedOption' : ''}
                >
                  {option.title}
                  {option.productImage && (
                    <span className="optionImage">
                      <img src={option.productImage} alt={option.title} />
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}

        {hasImage && (
          <GridModal
            title={labelName}
            show={isOpen}
            data={options}
            hasImage={true}
            selected={selectedValue}
            setSelected={setSelectedValue}
          />
        )}
      </div>
    </>
  );
};

export default SelectDropDownNew;